import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/mediabook/mediabook/src/templates/Course.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Video = makeShortcode("Video");
const FlashCard = makeShortcode("FlashCard");
const Prompt = makeShortcode("Prompt");
const Answer = makeShortcode("Answer");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Code Quality`}</h1>
    <p>{`In this video, you'll learn to write good quality code that is easy to understand and debug. This is
an extremely important skill to build, whether you're writing code for your own projects or with
others!`}</p>
    <p>{`We'll talk about the PEP 8 style guide, which you can find here:
`}<a parentName="p" {...{
        "href": "https://www.python.org/dev/peps/pep-0008/"
      }}>{`The PEP 8 Style Guide`}</a></p>
    <p>{`Too long of a read? `}<span parentName="p" {...{
        "role": "img",
        "aria-label": "musical notes"
      }}>{`🎶`}</span>{` Try starting with the very entertaining musical version here:
`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=hgI0p1zf31k"
      }}>{`The PEP 8 Song`}</a></p>
    <Video alt="Code Quality" videoId="8Udh2_QIq2U" mdxType="Video" />
    <p>{`Too long of a listen? Here are the strategies from the video again. Your future self and future
collaborators will thank you for making sure you always remember to write good quality code!`}</p>
    <ul>
      <li parentName="ul"><span parentName="li" {...{
          "role": "img",
          "aria-label": "check mark button"
        }}>{`✅`}</span>{` Use descriptive names`}</li>
      <li parentName="ul"><span parentName="li" {...{
          "role": "img",
          "aria-label": "check mark button"
        }}>{`✅`}</span>{` Use proper indentation`}</li>
      <li parentName="ul"><span parentName="li" {...{
          "role": "img",
          "aria-label": "check mark button"
        }}>{`✅`}</span>{` Use helpful comments and docstrings`}</li>
      <li parentName="ul"><span parentName="li" {...{
          "role": "img",
          "aria-label": "check mark button"
        }}>{`✅`}</span>{` Use the DRY principle`}</li>
      <li parentName="ul"><span parentName="li" {...{
          "role": "img",
          "aria-label": "check mark button"
        }}>{`✅`}</span>{` Use the PEP 8 style guide`}</li>
      <li parentName="ul"><span parentName="li" {...{
          "role": "img",
          "aria-label": "cross mark"
        }}>{`❌`}</span>{` Avoid long and complex lines of code`}</li>
    </ul>
    <h2>{`Check Your Understanding`}</h2>
    <FlashCard mdxType="FlashCard">
      <Prompt mdxType="Prompt">
        <p>{`What are two strategies you can use to write good quality code?`}</p>
      </Prompt>
      <Answer mdxType="Answer">
        <p>{`You could use any of these strategies (and more!) to make sure that your code is easy to understand,
maintain, and debug.`}</p>
        <ul>
          <li parentName="ul">{`Use descriptive names`}</li>
          <li parentName="ul">{`Use proper indentation`}</li>
          <li parentName="ul">{`Use helpful comments and docstrings`}</li>
          <li parentName="ul">{`Use the DRY principle`}</li>
          <li parentName="ul">{`Use the PEP 8 style guide`}</li>
          <li parentName="ul">{`Avoid long and complex lines of code`}</li>
        </ul>
      </Answer>
    </FlashCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      